import { motion } from 'framer-motion';
import { FileCog } from 'lucide-react';

import { PipelineProcessingStages } from '@/constants/pipelineStatus';

interface ProcessingPipelineUpdatesProps {
  pipelineStepTitle: string;
  pipelineStepSubTitle: string;
  stepNumber: number;
}

const ProcessingPipelineUpdates = ({
  pipelineStepTitle,
  pipelineStepSubTitle,
  stepNumber,
}: ProcessingPipelineUpdatesProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex h-full w-full flex-col rounded-lg border border-gray-200 bg-white shadow-sm"
    >
      <div className="flex items-center justify-between rounded-t-lg border-b border-gray-100 bg-gray-50/80 px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-50 ring-1 ring-blue-100">
            <FileCog className="h-4 w-4 text-blue-600" />
          </div>
          <h3 className="text-base font-semibold text-gray-900">{pipelineStepTitle}</h3>
        </div>
        {stepNumber > 0 && (
          <div className="rounded-full bg-gray-100 px-3 py-1 text-sm font-medium text-gray-600">
            Step {stepNumber}/{PipelineProcessingStages.length - 1}
          </div>
        )}
      </div>
      <div className="min-h-42 px-6 py-5">
        <div className="mb-4 flex items-center gap-3">
          <div className="h-2 w-2 animate-pulse rounded-full bg-blue-500" />
          <p className="text-sm text-gray-600">{pipelineStepSubTitle}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default ProcessingPipelineUpdates;
